import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Fmcsa = Loadable(lazy(() => import('./Fmcsa')));

const FmcsaRoutes = [
	{
		path: '/fmcsa',
		element: <Fmcsa />,
		auth: authRoles.admin,
	},
];

export default FmcsaRoutes;
